module.exports = __webpack_public_path__ + "static/media/qrcode_demo.801b20ce.png";